import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
///import Cookies from 'js-cookie';
import {Alert, Stack, Snackbar, LinearProgress} from '@mui/material';
///import { useSelector } from 'react-redux';
import {API_URL,LIVE_CLASS_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import '../styles/bizofficer-a.css';
///import 'font-awesome/css/font-awesome.min.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

function dateFormat(datetime){
	if(datetime && datetime!=null){
		let datetimeArr = datetime.split(" ");
		let dtArr = datetimeArr[0].split("-");
		let tmArr = datetimeArr[1].split(":");
		datetime = dtArr[2]+"-"+dtArr[1]+"-"+dtArr[0]+" "+tmArr[0]+":"+tmArr[1];
	}
	return datetime;
}  
  
  
const columns = [
	{ field: 'id', headerName: '#', width: 40 },
	{ field: 'subject', headerName: 'Subject', width: 290, renderCell: (cellValues) => {
		return <span title="Join Meeting" >{cellValues.row.subject} <i className="fa fa-play-circle" style={{fontSize:15, marginLeft:5, color:'#b33426'}} ></i></span>
	  }, 
	},
	{ field: 'startTime', headerName: 'Start Date/Time', type: 'date', width: 180, 
	   valueGetter: (params) => {
	   return dateFormat(params.value);
		 }},
	{ field: 'duration', headerName: 'Duration(Minutes)', width: 180 },
	{ field: 'note', headerName: 'Note', flex: 1 }
  ];
  
  export default function Execute() {
	const classes = useStyles();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	///const userObj = useSelector(state => state.userDetails);
	const [rows, setRows] = React.useState([]);
	const [pageLoading, setPageLoading] = React.useState(true);

	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}

	var vertical='top',horizontal='center';

	function hideAlert(){
		setShowAlert(false);
	}

	React.useEffect(() => {				
		if(etlStudentObj && etlStudentObj.loginId && etlStudentObj.token){			
			getApiData(etlStudentObj.loginId,etlStudentObj.token);
		}
	}, []);

	async function getApiData(loginId,token){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': loginId,
					'token': token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/myliveclasses', axiosHeader)
			   .then(response => {
				setPageLoading(false);
			 	///console.log("Just Checking >> "+response.data); 
				if(response.data && response.data.responseTxt==='success'){	
					if(response.data.obj && response.data.obj?.length>0){				 
						setRows(response.data.obj);	
					}else{
						setRows([]);
					}
				}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					window.location.href='logout';
					
				} 			 				
			})
	}

	function goToDetail(obj){
		if(obj && rows[obj.id-1] && rows[obj.id-1].meetingNumber && rows[obj.id-1].meetingNumber.length>0){
			window.location.href="jitsimeeting?meetingTitle="+rows[obj.id-1].subject+"&meetingId="+rows[obj.id-1].meetingNumber;
			//window.location.href=LIVE_CLASS_URL+"/?userName="+rows[obj.id-1].subject+"&meetingNumber="+rows[obj.id-1].meetingNumber+"&passWord="+rows[obj.id-1].meetingPassword;
		}else{
			setShowAlert(true);
			setAlertMessage("Live class is not started yet");
			return false;
		}
	}

	return (
		<div> 
				<MetaTags>
            		<title>My Teacher Help</title>
          		</MetaTags>
				
		    <Header />	
			<LeftDrawer />
			<main className={classes.content}>
			<NotificationAlerts />
			
				{pageLoading?<LinearProgress />:null}
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	
					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >My Teacher Help</h3>
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '60vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No live classes found!</span>
								  </Stack>
								)}}
							onRowClick={itm => goToDetail(itm)}			
						/>
					</div>

				</Box>
			</main>

						<Stack spacing={2} sx={{ width: '100%' }}>
							<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
								<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
									{alertMessage}
								</Alert>
							</Snackbar>
						</Stack>


		</div>	
	);
  }